/** Escape untrusted text before interpolating it into an HTML template. */
export function escapeHtml(value: unknown): string {
  return String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');
}

/**
 * Attribute values currently use the same encoding as text nodes. Keeping a
 * named helper documents the context and prevents future callers from assuming
 * that text can be inserted into an attribute without encoding.
 */
export const escapeHtmlAttr = escapeHtml;
